module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-orderTotal"
  }, [_c('div', {
    staticClass: "container heading"
  }, [_c('span', {
    staticClass: "m-orderTotal__amount"
  }, [_c('i', {
    staticClass: "fa fas fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalCurrency) + " " + _vm._s(_vm.totalAmount))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.taxChangeLoading),
      expression: "taxChangeLoading"
    }],
    staticClass: "m-orderTotal__mobileSpinner"
  }, [_c('i', {
    staticClass: "fad fa-spinner-third fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "a-Link--Blue nav-link m-orderTotal__btn",
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("View order")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6abead8c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/molecules/MobileNavTotalOrder.vue
// module id = 536
// module chunks = 2